import { DownloadCloud } from "lucide-react"

import { ActionTooltipButton } from "@components/buttons/ActionTooltipButton"

import { cn } from "@lib/utils"

interface DownloadContentButtonProps {
    content: string | object
    variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link"
    size?: "default" | "sm" | "lg" | "icon" | "xs"
    title?: boolean
    className?: string
}
export function DownloadContentButton({ content, variant, size, title = false, className }: Readonly<DownloadContentButtonProps>) {
    const handleOnSave = () => {
        const isJson = isJSON(content)
        const extension = isJson ? "json" : "txt"

        const fileName = `vertesia-document-${new Date().toISOString()}.${extension}`
        const file = textToFile(content, isJson, fileName)

        const url = window.URL.createObjectURL(file)
        const a = document.createElement("a")
        a.download = fileName
        a.href = url
        a.click()
    }

    return <ActionTooltipButton variant={variant || "outline"} size={size || "default"} text={title ? "Download" : undefined} tooltip="Download content" icon={<DownloadCloud />} onClick={handleOnSave} className={cn(className)} />
}

function textToFile(content: string | object, isJson: boolean, filename: string) {
    const value = isJson ? JSON.stringify(content, null, 2) : String(content)
    const type = isJson ? "application/json" : "text/plain"

    const blob = new Blob([value], { type: type })

    return new File([blob], `${filename}`, { type: type })
}

function isJSON(content: unknown): boolean {
    return !!content && typeof content === "object"
}
